import {Stack} from '@mantine/core';
import {PlatformLoader} from "@pac/platform-ui-components";

import {HeadingRow} from "../../credentials/components/HeadingRow.tsx";
import {HandoffSignInForm} from "../forms/HandoffSignInForm.tsx";
import {HandoffMessage} from "../components/HandoffMessage.tsx";
import {useHandoff} from "../hooks/useHandoff.ts";
import {MODULE_CONFIG} from "../config";

export const IndexPage = () => {

    const {
        state,
        initialEmail,
        handleSignIn,
    } = useHandoff();

    if (state.phase === 'error') {
        return <HandoffMessage message={state.message}/>;
    }

    if (state.phase === 'checking' || state.phase === 'redirecting') {
        return <PlatformLoader message="Signing you in...Please wait"/>;
    }

    return (
        <Stack gap={'xl'}>
            <HeadingRow title={MODULE_CONFIG.title}/>
            {state.signInError && <HandoffMessage message={state.signInError}/>}
            <HandoffSignInForm
                emailAddress={initialEmail}
                handleSubmit={handleSignIn}
            />
        </Stack>
    );
};
